import { useMemo } from "react"
import {
  useFractionalPartnerFeesMutation,
  useLazyGetBankNameQuery,
  useLazyGetPaymentModeQuery,
  useLazyGetValidateReferenceNumberQuery,
} from "features/leads/api"

export function useFractionalSalePaymentApis() {
  const [getBankName, banksQuery] = useLazyGetBankNameQuery()
  const [getPaymentMode, paymentModeQuery] = useLazyGetPaymentModeQuery()
  const [validateReference, referenceQuery] = useLazyGetValidateReferenceNumberQuery()
  const [
    fractionalPartnerFees,
    {
      data: psidFeeData,
      isLoading: loadingPsidProcessingFees,
      isSuccess: psidFeesFetchSuccess,
      isError: psidFeesError,
    },
  ] = useFractionalPartnerFeesMutation()

  return useMemo(
    () => ({
      getBankName,
      getPaymentMode,
      validateReference,
      banks: banksQuery.data,
      paymentMode: paymentModeQuery.data,
      isLoadingPaymentMode: paymentModeQuery.isFetching,
      referenceError: referenceQuery.isError,
      referenceValidity: referenceQuery.data,
      fractionalPartnerFees,
      psidFeeData,
      loadingPsidProcessingFees,
      psidFeesFetchSuccess,
      psidFeesError,
    }),
    [
      getBankName,
      getPaymentMode,
      validateReference,
      banksQuery.data,
      banksQuery.isFetching,
      paymentModeQuery.data,
      paymentModeQuery.isFetching,
      referenceQuery.isError,
      referenceQuery.data,
      fractionalPartnerFees,
      psidFeeData,
      loadingPsidProcessingFees,
      psidFeesFetchSuccess,
      psidFeesError,
    ]
  )
}
